// IDs vêm do ENG_APP_Platform: `ascAppId` no eas.json e `android.package` no app.json.
const APP_STORES = {
    ios: 'https://apps.apple.com/br/app/id6802671054',
    android: 'https://play.google.com/store/apps/details?id=app.whizr.android',
};

export default APP_STORES;
